module.exports = __webpack_public_path__ + "static/media/qrMasterbox.b6af78d4.jpg";